<template>
    <svg viewBox="0 0 24 24">
        <path d="M17 9.5L12 14.5L7 9.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>